import React, { useEffect, createElement, Component } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { Safety } from './pages/Safety';
import { HowItWorks } from './pages/HowItWorks';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Help } from './pages/Help';
import { HelpArticle } from './pages/HelpArticle';
// ScrollToTop component to handle scroll restoration
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
// Google Tag Manager Component
const GTM_ID = 'GTM-M3CLLN6G';
function GTM() {
  useEffect(() => {
    // GTM Head Script
    const scriptId = 'gtm-script';
    if (document.getElementById(scriptId)) return;
    const script = document.createElement('script');
    script.id = scriptId;
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`;
    // Insert as high as possible in head
    document.head.insertBefore(script, document.head.firstChild);
  }, []);
  return <noscript data-id="element-0">
      <iframe src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`} height="0" width="0" style={{
      display: 'none',
      visibility: 'hidden'
    }} data-id="element-1" />
    </noscript>;
}
// Favicons Component
function Favicons() {
  useEffect(() => {
    const links = [{
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: 'https://cdn.magicpatterns.com/uploads/jhq9CnEhXo7pM14ZXJx8Ym/apple-touch-icon.png'
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: 'https://cdn.magicpatterns.com/uploads/qndz9coVNcoqVoGJovEgbM/favicon-32x32.png'
    }, {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: 'https://cdn.magicpatterns.com/uploads/vf2kCRqPdB5U6L26XSJcRp/favicon-16x16.png'
    }, {
      rel: 'manifest',
      href: '/site.webmanifest'
    }];
    links.forEach(({
      rel,
      sizes,
      href,
      type
    }) => {
      // Check if link already exists to avoid duplicates
      if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      if (sizes) link.sizes = sizes;
      if (type) link.type = type;
      document.head.appendChild(link);
    });
  }, []);
  return null;
}
export function App() {
  return <Router data-id="element-2">
      <GTM data-id="element-3" />
      <Favicons data-id="element-4" />
      <ScrollToTop data-id="element-5" />
      <Routes data-id="element-6">
        <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
        <Route path="/pricing" element={<Pricing data-id="element-10" />} data-id="element-9" />
        <Route path="/safety" element={<Safety data-id="element-12" />} data-id="element-11" />
        <Route path="/how-it-works" element={<HowItWorks data-id="element-14" />} data-id="element-13" />
        <Route path="/privacy" element={<Privacy data-id="element-16" />} data-id="element-15" />
        <Route path="/terms" element={<Terms data-id="element-18" />} data-id="element-17" />
        <Route path="/help" element={<Help data-id="element-20" />} data-id="element-19" />
        <Route path="/help/:slug" element={<HelpArticle data-id="element-22" />} data-id="element-21" />
      </Routes>
    </Router>;
}